<template>
  <canvas ref="canvasEl"></canvas>
</template>

<script setup>
import { ref, toRefs, onMounted } from 'vue'
import { Chart, BarController, BarElement, PointElement, LinearScale, CategoryScale, Tooltip, Title, Legend } from 'chart.js'
Chart.register(BarController, BarElement, PointElement, LinearScale, CategoryScale, Tooltip, Title, Legend)

const props = defineProps({
  data: {
    type: Object,
    required: true
  },
  options: {
    type: Object,
    required: true
  }
})

const { data, options } = toRefs(props)
const canvasEl = ref(undefined)

onMounted(() => {
  new Chart(canvasEl.value, {
    type: 'bar',
    data: data.value,
    options: options.value
  })
})
</script>
